var _rect, _path, _rect2, _rect3, _rect4, _path2, _path3, _path4, _circle, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBgRed = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 399,
  height: 102,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 399,
  height: 102,
  rx: 4,
  fill: "url(#BG-red_svg__a)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M146.408 16.472a1.5 1.5 0 0 1 2.12-.064l8.5 8a1.5 1.5 0 0 1-2.056 2.184l-8.5-8a1.5 1.5 0 0 1-.064-2.12Zm13.5 13a1.5 1.5 0 0 1 2.12-.064l8.5 8a1.5 1.5 0 0 1-2.056 2.184l-8.5-8a1.5 1.5 0 0 1-.064-2.12Zm-2.816 0a1.5 1.5 0 0 1-.064 2.12l-8.5 8a1.5 1.5 0 1 1-2.056-2.184l8.5-8a1.5 1.5 0 0 1 2.12.064Zm13.469-10.911a1.501 1.501 0 0 0-2.122-2.121l-8 8a1.5 1.5 0 0 0 2.122 2.121l8-8ZM307.732 15.732a2.5 2.5 0 0 0 0 3.536l6.965 6.964-6.471 6.471a2.5 2.5 0 0 0 3.536 3.536l6.47-6.471 6.471 6.47a2.5 2.5 0 1 0 3.535-3.535l-6.47-6.47 6.964-6.965a2.499 2.499 0 1 0-3.535-3.535l-6.965 6.964-6.964-6.965a2.5 2.5 0 0 0-3.536 0ZM99.861 45.784a2.677 2.677 0 0 0 0 3.786l3.354 3.353-3.431 3.43a2.677 2.677 0 0 0 3.786 3.786l3.43-3.43 3.43 3.43a2.677 2.677 0 0 0 3.786-3.786l-3.43-3.43 3.353-3.352a2.678 2.678 0 0 0-3.786-3.786L107 49.137l-3.353-3.353a2.677 2.677 0 0 0-3.786 0Z",
  fill: "#fff"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 23.172,
  y: 50.538,
  width: 10.324,
  height: 10.324,
  rx: 5,
  transform: "rotate(-45.522 23.172 50.538)",
  stroke: "#fff",
  strokeWidth: 4
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 307.586,
  y: 89.526,
  width: 8.324,
  height: 8.324,
  rx: 4,
  transform: "rotate(-45.522 307.586 89.526)",
  stroke: "#fff",
  strokeWidth: 2
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 227.172,
  y: 15.539,
  width: 10.324,
  height: 10.324,
  rx: 5,
  transform: "rotate(-45.522 227.172 15.539)",
  stroke: "#fff",
  strokeWidth: 4
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.7,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M62.764 14.695a2.372 2.372 0 0 0 0 3.355l2.971 2.972-3.04 3.04a2.373 2.373 0 0 0 3.355 3.355l3.04-3.04 3.04 3.04a2.373 2.373 0 0 0 3.356-3.355l-3.04-3.04 2.971-2.972a2.373 2.373 0 0 0-3.355-3.355l-2.971 2.971-2.972-2.971a2.372 2.372 0 0 0-3.355 0Z",
  fill: "#fff"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M50.386 74.386a1.318 1.318 0 0 0 0 1.864l3.672 3.672-3.412 3.411a1.318 1.318 0 0 0 1.864 1.864l3.412-3.411 3.411 3.411a1.318 1.318 0 0 0 1.864-1.864l-3.411-3.411 3.672-3.672a1.318 1.318 0 0 0-1.864-1.864l-3.672 3.672-3.672-3.672a1.318 1.318 0 0 0-1.864 0Z",
  fill: "#fff"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.7,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M249.408 54.472a1.5 1.5 0 0 1 2.12-.064l4.481 4.217c.212.2.353.446.422.707.066-.247.195-.481.389-.675l4.218-4.218a1.5 1.5 0 1 1 2.121 2.122l-4.217 4.217a1.504 1.504 0 0 1-.492.328c.068.045.134.097.195.155l4.482 4.218a1.5 1.5 0 0 1-2.056 2.185l-4.482-4.218a1.497 1.497 0 0 1-.29-.375 1.497 1.497 0 0 1-.29.375l-4.481 4.218a1.5 1.5 0 1 1-2.056-2.185l4.481-4.218c.096-.09.201-.165.311-.225a1.516 1.516 0 0 1-.311-.226l-4.481-4.218a1.5 1.5 0 0 1-.064-2.12Zm7.64 6.494a1.496 1.496 0 0 1-.617-.862 1.503 1.503 0 0 1-.733.932 1.506 1.506 0 0 1 .601.6 1.5 1.5 0 0 1 .749-.671Z",
  fill: "#fff"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.5,
  cx: 366.5,
  cy: 66.5,
  r: 21,
  stroke: "#fff",
  strokeWidth: 15
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M239.997 102c.002-.166.003-.333.003-.5 0-22.368-18.132-40.5-40.5-40.5S159 79.132 159 101.5c0 .167.001.334.003.5h-3a41.545 41.545 0 0 1-.003-.5c0-24.024 19.476-43.5 43.5-43.5S243 77.476 243 101.5c0 .167-.001.334-.003.5h-3Z",
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "BG-red_svg__a",
  x1: 0,
  y1: 102,
  x2: 399,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD7D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7C2C2"
})))));
export { SvgBgRed as ReactComponent };
export default __webpack_public_path__ + "1f608a1146176792c81038c04c2b561b.svg";